module.exports = __webpack_public_path__ + "static/client_14-fed05ed5e947dea293da3b3ba8844558.png";